import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

const styles = {

    root: {
        marginLeft:'16px',
        boxShadow: 'none',
        textTransform: 'none',
        fontSize: 14,
        padding: '5px 8px',
        border: '1px solid black',
        borderRadius: '2px',
        lineHeight: 1.5,
        backgroundColor: '#007bff00',
        color:'black',
        boxShadow:'0 8px 12px 0 rgba(0, 0, 0, 0.02), 0 6px 20px 0 rgba(0, 0, 0, 0.02)',
        fontFamily: [
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
          backgroundColor: '#0069d9',
          border: '1.5px solid black',
        },
        '&:active': {
          boxShadow: 'none',
          backgroundColor: '#0062cc',
          border: '1.5px solid black',
        },
        '&:focus': {
          backgroundColor: '#3f51b570',
          boxShadow: 'none',
          border: '1.5px solid black',
        },
      },
};

  const useStyles = makeStyles(theme => ({
    margin: {
      margin: theme.spacing(1),
    },
  }));

class CustomButton extends React.Component {
  constructor(props){
    super(props);
    }

  render() {
    const { classes } = this.props;

    return (
      <Button variant="outlined" color="primary" disableRipple className={classes.root} onClick={this.props.click}>
        {this.props.name}
      </Button>
    );
  }
}

CustomButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CustomButton);